module.exports = __webpack_public_path__ + "img/mittige_einzellast.2e151527.jpg";